






















































import { Component, Vue } from "vue-property-decorator";
import { Getter, Action } from "vuex-class";
import Message from "@/components/notification/Message.vue";
import { NotificationMessage } from "@/modules/NotificationMessage";
import _ from "lodash";

@Component({components: { Message }})
export default class Notification extends Vue {
  protected refreshTimer: ReturnType<typeof setInterval> | null = null;
  @Action("loadNotificationMessages") protected loadNotificationMessages!: () => Promise<void>;
  @Action("deleteAllMessages") protected deleteAllMessages!: (seenOnly: boolean) => Promise<void>;
  @Action("seenAllMessages") protected seenAllMessages!: () => Promise<void>;

  @Getter("getNotificationMessages") public messages!: NotificationMessage[];

  protected created(): void {
    this.loadNotificationMessages().then(() => {
      this.refreshTimer = setInterval(() => {
        this.loadNotificationMessages()
          .catch(() => {
            // Stop reloading messages if an error occurs
            if (this.refreshTimer) {
              clearInterval(this.refreshTimer);
            }
          });
      }, 180000); // 3 minutes
    });
  }

  protected beforeDestroy(): void {
    if (this.refreshTimer) {
      clearInterval(this.refreshTimer);
    }
  }

  protected get hasUnreadMessages(): boolean {
    return this.messages.some((message) => !message.seenAt);
  }

  protected get hasReadMessages(): boolean {
    return this.messages.some((message) => !!message.seenAt);
  }

  protected get unreadMessagesCount(): number {
    return this.messages.filter((message) => !message.seenAt).length;
  }

  protected seenAll(): void {
    this.$confirm(
      _.invoke(
        this.$options.filters,
        "trans",
        "markSeenAllMessages"
      ) + " ?",
      {
        confirmButtonText: _.invoke(this.$options.filters, "trans", "yes"),
        cancelButtonText: _.invoke(this.$options.filters, "trans", "no"),
      }).then(() => {
      this.seenAllMessages().then(() => {
        this.$message({
          message: _.invoke(this.$options.filters, "trans", "notificationMessagesHaveBeenSeen"),
          type: "success"
        });
      }).catch(() => {
        this.$message({
          message: _.invoke(this.$options.filters, "trans", "errorDuringNotificationMessagesSeeing"),
          type: "error"
        });
      });
    })
    ;
  }

  protected deleteAll(seenOnly: boolean = false): void {
    this.$confirm(
      _.invoke(
        this.$options.filters,
        "trans",
        seenOnly ? "deleteSeenMessages" : "deleteAll"
      ) + " ?",
      {
        confirmButtonText: _.invoke(this.$options.filters, "trans", "yes"),
        cancelButtonText: _.invoke(this.$options.filters, "trans", "no"),
      }).then(() => {
        this.deleteAllMessages(seenOnly).then(() => {
          this.$message({
            message: _.invoke(this.$options.filters, "trans", "notificationMessagesHaveBeenDeleted"),
            type: "success"
          });
        }).catch(() => {
          this.$message({
            message: _.invoke(this.$options.filters, "trans", "errorDuringNotificationMessagesDeletion"),
            type: "error"
          });
        });
      })
    ;
  }

  protected closePopper(): void {
    const { popper } = this.$refs;
    (popper as any).doClose();
  }
}
